import { Id } from "@teachloop/backend/_generated/dataModel";
import { useState, useCallback } from "react";

export type LessonQuantities = Record<
  Id<"students">,
  {
    remote?: number;
    inPerson?: number;
  }
>;

function useLessonQuantities(studentIds: Id<"students">[]) {
  const [lessonQuantities, setLessonQuantities] = useState<LessonQuantities>(
    () =>
      studentIds.reduce((acc, id) => {
        acc[id] = { remote: 0, inPerson: 0 };
        return acc;
      }, {} as LessonQuantities)
  );

  const setQuantity = useCallback(
    (studentId: Id<"students">, type: "remote" | "inPerson", value: number) => {
      setLessonQuantities((prev) => ({
        ...prev,
        [studentId]: {
          ...prev[studentId],
          [type]: value,
        },
      }));
    },
    []
  );

  const resetStudent = useCallback((studentId: Id<"students">) => {
    setLessonQuantities((prev) => ({
      ...prev,
      [studentId]: { remote: 0, inPerson: 0 },
    }));
  }, []);

  return {
    lessonQuantities,
    setQuantity,
    resetStudent,
  };
}

export default useLessonQuantities;